import { Client } from 'urql';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';
import { IconName } from 'views/utils/handleIcon';
import { LogoutDocument } from 'views/utils/graphql/graphql';

export type MenuButtonProps = {
  to: string;
  action?: Function;
  className?: string;
  iconName: IconName;
  label: string;
};

export const middleMenuData: MenuButtonProps[] = [
  { to: CustomerPagePath.Home, iconName: IconName.Home, label: 'ホーム' },
  {
    to: CustomerPagePath.ProductList,
    iconName: IconName.List,
    label: '募集銘柄一覧',
  },
  {
    to: CustomerPagePath.OrderStatus,
    iconName: IconName.Repeat,
    label: '申込履歴',
  },
  { to: CustomerPagePath.Notice, iconName: IconName.Alert, label: 'お知らせ' },
  {
    to: CustomerPagePath.DocumentGrant,
    iconName: IconName.Document,
    label: '交付書面',
  },
  {
    to: CustomerPagePath.AccountInfo,
    iconName: IconName.Setting,
    label: '登録情報',
  },
  {
    to: CustomerPagePath.ChangePassword,
    iconName: IconName.Setting,
    label: 'パスワード変更',
  },
];

export const bottomMenuData: MenuButtonProps[] = [
  // { to: CustomerPagePath.Login, iconName: IconName.SignOut, label: "ログイン" },
  {
    to: CustomerPagePath.Contact,
    iconName: IconName.Help,
    label: 'お問い合わせ',
  },
  {
    to: CustomerPagePath.Login,
    action: async (client: Client) => {
      await client.mutation(LogoutDocument, {}, { requestPolicy: 'network-only' });

      sessionStorage.removeItem('token');
      sessionStorage.removeItem('last_4_digits');
    },
    iconName: IconName.SignOut,
    label: 'ログアウト',
  },
];

export const bottomMenuDataPath: MenuButtonProps[] = [
  {
    to: CustomerPagePath.ReissuePassword,
    iconName: IconName.SignOut,
    label: 'パスワード再発行',
  },
  {
    to: CustomerPagePath.SendSMS,
    iconName: IconName.SignOut,
    label: 'SMS認証',
  },
  {
    to: CustomerPagePath.Contact,
    iconName: IconName.Help,
    label: 'お問い合わせ',
  },
  {
    to: CustomerPagePath.Login,
    iconName: IconName.SignOut,
    label: '',
  },
];

const menuData: MenuButtonProps[] = middleMenuData.concat(bottomMenuDataPath);

export const findPathName = (path: string) => {
  return menuData.find((pathData) => pathData.to === path)?.label || '';
};
